import { formatTime } from "../../../../hooks/helper";

export interface UnitType {
  id: string | null;
  unitTypeName: string | null;
  storageType: string | null;
  sizeFt3: number | null;
  unitWidth: number | null;
  unitLength: number | null;
  unitHeight: number | null;
  rentType: string | null;
  unitNumbering: string | null;
  prefix: string | null;
  pricePerUnit: number | null;
  quantity: number | null;
  siteAccessHours: string | null;
  accessStartTime: string | null;
  accessEndTime: string | null;
  securityDepositType: string | null;
  securityDepositValue: number | null;
}

export interface SiteUnit {
  id: string | null;
  unitTypeId: string | null;
  storageType: string | null;
  sizeFt3: number | null;
  unitWidth: number | null;
  unitLength: number | null;
  unitHeight: number | null;
  rentType: string | null;
  unitNumbering: string | null;
  prefix: string | null;
  rangeStart: string | null;
  rangeEnd: string | null;
  pricePerUnit: number | null;
  quantity: number | null;
  siteAccessHours: string | null;
  accessStartTime: string | null;
  accessEndTime: string | null;
  securityDepositType: string | null;
  securityDepositValue: number | null;
}

/**
 * Keyboard codes that should always be allowed through a field's
 * pattern filter (navigation / editing keys), regardless of the
 * field's own `patternAllowed` regex.
 */
export const ALWAYS_ALLOWED_KEY_CODES = [8, 9, 17, 18, 37, 38, 39, 40];

export const NOTES_FIELD_ID = "notes";
export const NOTES_EXPAND_THRESHOLD = 36;

/**
 * Builds a fully-populated UnitType object from the record returned
 * by the API (snake_case) so the form always works with a consistent,
 * camelCase local shape.
 */
export const mapSelectDataToUnitType = (selectData: any): UnitType => ({
  id: selectData?.id,
  unitTypeName: selectData.unit_type_name ?? null,
  storageType: selectData.storage_type ?? null,
  sizeFt3: selectData.size_ft3 ?? null,
  unitWidth: selectData.unit_width ?? null,
  unitLength: selectData.unit_length ?? null,
  unitHeight: selectData.unit_height ?? null,
  rentType: selectData.rent_type ?? null,
  prefix: selectData.prefix ?? null,
  pricePerUnit: selectData.price_per_unit ?? null,
  unitNumbering: selectData.unit_numbering ?? null,
  quantity: selectData.quantity ?? null,
  siteAccessHours: selectData.site_access_hours ?? null,
  accessStartTime: formatTime(selectData.access_start_time) ?? null,
  accessEndTime: formatTime(selectData.access_end_time) ?? null,
  securityDepositType: selectData.security_deposit_type ?? null,
  securityDepositValue: selectData.security_deposit_value ?? null,
});
